module.exports = __webpack_public_path__ + "static/media/image-1.2a2d3c52.png";